module.exports = __webpack_public_path__ + "img/YN11X5.png";